<template>
  <div class="EscuelasListado">
    <md-table
      v-model="filtro_escuelas"
      md-sort="nombre_esc"
      md-sort-order="asc"
      md-fixed-header
      md-card
    >
      <md-table-toolbar>
        <div class="md-toolbar-section-start md-title">Escuelas</div>
        <div class="md-toolbar-section-end">
          <md-field md-clearable>
            <md-input
              placeholder="Buscar escuela..."
              v-model="buscar"
            />
          </md-field>
          <md-button
            v-if="$session.get('tipo') === 'administrador'"
            class="md-icon-button"
            to="/escuela"
          >
            <md-icon>add</md-icon>
          </md-button>
        </div>
      </md-table-toolbar>
      <md-table-row
        slot="md-table-row"
        slot-scope="{ item }"
        class="upper"
      >
        <md-table-cell
          md-label="Nombre"
          md-sort-by="nombre_esc"
        >
          {{item.nombre_esc}}
        </md-table-cell>
        <md-table-cell
          md-label="Clave"
          md-sort-by="clave_esc"
        >
          {{item.clave_esc}}
        </md-table-cell>

        <md-table-cell
          md-label="Alias"
          md-sort-by="alias_esc"
        >
          {{item.alias_esc}}
        </md-table-cell>

        <md-table-cell
          md-label="Tipo"
          md-sort-by="tipo_esc"
        >
          {{item.tipo_esc}}
        </md-table-cell>
        <md-table-cell
          md-label="Nivel"
          md-sort-by="nivel_esc"
        >
          {{item.nivel_esc}}
        </md-table-cell>

        <md-table-cell md-numeric>
          <md-button
            :to="`/escuela/${item.id}`"
            class="md-icon-button md-dense"
          >
            <md-icon>edit</md-icon>
          </md-button>
        </md-table-cell>
      </md-table-row>
    </md-table>
    <md-card-content>
      <md-progress-bar
        md-mode="indeterminate"
        class="md-accent"
        v-if="cargando"
      />
    </md-card-content>
  </div>
</template>

<script>
const toLower = text => {
  return text.toString().toLowerCase();
};
const buscarEsc = (items, term) => {
  if (term) {
    return items.filter(
      item =>
        toLower(item.nombre_esc).includes(toLower(term)) ||
        toLower(item.clave_esc).includes(toLower(term)) ||
        toLower(item.alias_esc).includes(toLower(term)) ||
        toLower(item.tipo_esc).includes(toLower(term)) ||
        toLower(item.nivel_esc).includes(toLower(term))
    );
  }
  return items;
};

export default {
  name: "EscuelasListado",
  methods: {
    buscarEnLaTabla() {
      this.filtro_escuelas = buscarEsc(this.escuelas, this.buscar);
    },
    _falloResponse(err) {
      this.cargando = false;
      if (err.status === 401) {
        this.$router.push("/login");
      } else {
        this.$emit("msg", this.$no_internet);
      }
    },
    _obtenerEscuelas() {
      this.cargando = true;
      this.$http.get("escuelas", this.$headers).then(
        res => {
          this.cargando = false;
          if (res.status === 401) {
            this.$router.push("/login");
          } else if (res.status === 200 && "escuelas" in res.body) {
            this.escuelas = res.body.escuelas;
            localStorage.setItem("escuelas", JSON.stringify(res.body.escuelas));
            if (!localStorage.getItem("escuelas_contactos")) {
              localStorage.setItem(
                "escuelas",
                JSON.stringify(res.body.escuelas_contactos)
              );
            }
            if (!localStorage.getItem("escuelas_citas")) {
              localStorage.setItem(
                "escuelas",
                JSON.stringify(res.body.escuelas_citas)
              );
            }
            /*
            localStorage.setItem(
              "escuelas_contactos",
              JSON.stringify(res.body.escuelas_contactos)
            );
            localStorage.setItem(
              "escuelas_citas",
              JSON.stringify(res.body.escuelas_citas)
            );
            */
          } else {
            this.$emit("msg", res.body.error);
          }
        },
        err => this._falloResponse(err)
      );
    },
    _syncEscuelas() {}
    /*
    subirEvidencia(a) { this.escuela.id = a.id; this.escuela.id_esc = a.id_esc; this.escuela.nombre_esc = a.nombre_esc; this.escuela.clave_esc = a.clave_esc; this.escuela.alias_esc = a.alias_esc; this.escuela.tipo_esc = a.tipo_esc; this.escuela.nivel_esc = a.nivel_esc; this.showDialogEvidencia = true; }, donothing() {}, subirImagen(e) { if (e) { var reader = new FileReader(); reader.readAsDataURL(e[0]); reader.onload = f => this.b64.push(f.target.result); } else { this.b64 = null; } }, borrarImagen(a) { this.b64.splice(a, 1); }, _guardarEvidencia() { this.escuelas_evidencia.push({ id_esc: this.escuela.id_esc, archivos: this.b64 }); this.$emit( "msg", `Evidencia de la escuela ${this.escuela.clave_esc}, ${this.escuela.nombre_esc} guardada` ); localStorage.setItem( "escuelas_evidencia", JSON.stringify(this.escuelas_evidencia) ); this.showDialogEvidencia = false; }
    */
  },
  data() {
    return {
      b64: [],
      showDialogEvidencia: false,
      showDialogEvidenciaConfirm: false,
      showDialogEvidenciaAlert: false,
      textoEvidencia: "",
      cargando: false,
      showRegistro: false,
      buscar: null,
      escuelas: [],
      escuelaEdit: null,
      escuela: {
        id_esc: null,
        nombre_esc: null,
        clave_esc: null,
        alias_esc: null,
        tipo_esc: null,
        nivel_esc: null
      },
      errores: {
        nombre_esc: null,
        clave_esc: null,
        alias_esc: null,
        tipo_esc: null,
        nivel_esc: null
      },
      filtro_escuelas: [],
      escuelas_evidencia: []
    };
  },
  watch: {
    escuelas: {
      handler() {
        localStorage.setItem("escuelas", JSON.stringify(this.escuelas));
        this.filtro_escuelas = this.escuelas;
      },
      deep: true
    },
    buscar(a) {
      this.buscarEnLaTabla();
    },
    showDialogEvidencia(a) {
      if (!a) {
        this.b64 = [];
        this.escuela.id = null;
        this.escuela.id_esc = null;
        this.escuela.nombre_esc = null;
        this.escuela.clave_esc = null;
        this.escuela.alias_esc = null;
        this.escuela.tipo_esc = null;
        this.escuela.nivel_esc = null;
      }
    }
  },
  mounted() {
    if (this.$session.get("tipo") === "administrativo" && this.isOnline) {
      this._obtenerEscuelas();
    } else {
      if (localStorage.getItem("escuelas")) {
        this.escuelas = JSON.parse(localStorage.getItem("escuelas"));
      }
    }
    //if (!localStorage.getItem("escuelas_evidencia")) { localStorage.setItem("escuelas_evidencia", JSON.stringify([])); } else { this.escuelas_evidencia = JSON.parse( localStorage.getItem("escuelas_evidencia") ); }
  },
  beforeDestroy() {
    //localStorage.setItem( "escuelas_evidencia", JSON.stringify(this.escuelas_evidencia) );
  },
  beforeCreate() {
    if (!this.$session.exists()) {
      this.$emit("visible", false);
      this.$router.push("/login");
    } else {
      this.$emit("visible", true);
      this.$emit("classes", "container");
    }
  }
};
</script>
